import { ChevronLeft, ChevronRight, KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material';
import { PaginationButton, PaginationItem, PaginationList } from '@components/Styles/CommonStyle';

import React from 'react';

const Pagination = ({ 
  count, 
  page, 
  onChange, 
  onProjectSearchFlag = false 
}) => {
  const handleFirstPage = () => {
    if (!onProjectSearchFlag) onChange(1);
    else onChange({page: 1, manualSearch: false, status: '', init: false});
  };
  const handleLastPage = () => {
    if (!onProjectSearchFlag) onChange(count);
    else onChange({page: count, manualSearch: false, status: '', init: false});
  };
  const handlePreviousPage = () => {
    if (!onProjectSearchFlag) onChange(Math.max(page - 1, 1));
    else onChange({page: Math.max(page - 1, 1), manualSearch: false, status: '', init: false});
  };
  const handleNextPage = () => {
    if (!onProjectSearchFlag) onChange(Math.min(page + 1, count));
    else onChange({page: Math.min(page + 1, count), manualSearch: false, status: '', init: false});
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= count; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationButton active={i === page} onClick={
            () => {
              if (!onProjectSearchFlag) onChange(i);
              else onChange({page: i, manualSearch: false, status: '', init: false});
            }
          }>
            {i}
          </PaginationButton>
        </PaginationItem>,
      );
    }
    return pages;
  };

  return (
    <PaginationList>
      <PaginationItem>
        <PaginationButton onClick={handleFirstPage} disabled={page === 1}>
          <KeyboardDoubleArrowLeft />
        </PaginationButton>
      </PaginationItem>

      <PaginationItem>
        <PaginationButton onClick={handlePreviousPage} disabled={page === 1}>
          <ChevronLeft />
        </PaginationButton>
      </PaginationItem>

      {renderPageNumbers()}

      <PaginationItem>
        <PaginationButton onClick={handleNextPage} disabled={page === count}>
          <ChevronRight />
        </PaginationButton>
      </PaginationItem>

      <PaginationItem>
        <PaginationButton onClick={handleLastPage} disabled={page === count}>
          <KeyboardDoubleArrowRight />
        </PaginationButton>
      </PaginationItem>
    </PaginationList>
  );
};

export default Pagination;
